import {connect} from 'react-redux';
import classNames from 'classnames';

import Icon from './_icon';
import PageMonitors from './_page_monitoring/_page_monitors';

class RivalsFilter extends React.Component {

  static contextTypes = {
    utils: PropTypes.object.isRequired
  };

  static propTypes = {
    filterByRivals: PropTypes.arrayOf(PropTypes.number),
    totalCount: PropTypes.number,
    testIfChecked: PropTypes.func,
    onRivalClick: PropTypes.func,
    rivals: PropTypes.object.isRequired,
    loadOrFetchRivals: PropTypes.func.isRequired,
    viewingSingleMonitor: PropTypes.bool
  };

  static defaultProps = {
    filterByRivals: [],
    totalCount: 0,
    testIfChecked() {},
    onRivalClick() {},
    viewingSingleMonitor: false
  };

  state = {
    selectedRival: {},
    isPageMonitorsOpen: false
  };

  componentDidMount() {
    console.log('RivalsFilter.componentDidMount: props: %o', this.props);

    const {loadOrFetchRivals} = this.props;

    this._isMounted = true;

    loadOrFetchRivals();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleRivalClick = (rival = null, e) => {
    if(e) {
      e.preventDefault();
      e.stopPropagation();
    }

    this.props.onRivalClick(rival);
  };

  handleTogglePageMonitors = () =>
    this.setState(({isPageMonitorsOpen}) => ({
      isPageMonitorsOpen: !isPageMonitorsOpen
    }));

  handleEditClick = (e, rival) => {
    if(e) {
      e.stopPropagation();
    }

    this.setState(({isPageMonitorsOpen}) => ({
      isPageMonitorsOpen: !isPageMonitorsOpen,
      selectedRival: rival
    }));
  };

  render() {
    const {totalCount, filterByRivals, testIfChecked, rivals, viewingSingleMonitor} = this.props;
    const {selectedRival, isPageMonitorsOpen} = this.state;

    const uiRivals = [];

    // NOTE: this.props.rivals = null or empty object indicates rivals are still loading
    if(!rivals || _.isEmpty(rivals)) {
      return (
        <div key="loadingRivalFilters"><i className="fa fa-spin fa-spinner" /></div>
      );
    }

    const rivalsArray = (Object.values(rivals || {})).slice().sort((a, b) => a.name.localeCompare(b.name));

    // based on backend API architecture if we send 0 as rivalId we will get unassociated monitors. added this object here to be able to filter unassociated monitors as well.
    rivalsArray.unshift({id: 0, name: 'Unassociated Monitors'});

    rivalsArray.map(rival => {
      const isChecked = testIfChecked(rival);
      const filterOptionClass = classNames('rivals-filter_option', {
        'rivals-filter_option--selected': isChecked
      });
      const iconClass = classNames('fa', {
        'fa-check-square-o': isChecked,
        'fa-square-o': !isChecked
      });

      uiRivals.push(
        <div
          key={rival.id}
          className={filterOptionClass}
          onClick={() => this.handleRivalClick(rival)}>
          <i className={iconClass} />
          <p>{rival.name}</p>
          {// added rival.id !== 0 here since we should not show the edit icon for unassociated monitors
            (rival.id !== 0) &&
            <div
              className=" rivals-filter_option_actions rivals-filter_option_edit-icon"
              data-tracking-id="rivals-filter_option_edit-icon"
              onClick={e => this.handleEditClick(e, rival)}>
              <Icon icon="edit" width="18" height="18" />
            </div>}
        </div>

      );
    });

    // "all" filter at top of listing
    if(rivalsArray.length) {
      const filterLength = filterByRivals.length;
      const filterClass = classNames('rivals-filter_all', {
        'rivals-filter_option': true,
        'rivals-filter_option--selected': !filterLength && !viewingSingleMonitor
      });
      const iconClass = classNames({
        fa: true,
        'fa-square-o': Boolean(filterLength) || viewingSingleMonitor,
        'fa-check-square-o': !filterLength && !viewingSingleMonitor
      });
      let uiTotalCounter = null;

      if(totalCount && !viewingSingleMonitor) {
        uiTotalCounter = (
          <span>
            <span className="notification-badge notification-badge--grey">
              {Math.max(0, totalCount).toLocaleString()}
            </span>&nbsp;
          </span>
        );
      }

      uiRivals.push(
        <div key="rivalAll" ref="rivalAll" className={filterClass} onClick={() => this.handleRivalClick()}>
          <i className={iconClass} /> All
          <div className="rivals-filter_option_actions">
            {uiTotalCounter}
          </div>
        </div>
      );
    }

    return (
      <>
        <div className="rivals-filter">{uiRivals}</div>
        {isPageMonitorsOpen &&
        <PageMonitors
          rivalId={selectedRival.id}
          rival={selectedRival}
          onClose={this.handleTogglePageMonitors} />
        }
      </>
    );
  }

}

const mapDispatchToProps = dispatch => ({
  loadOrFetchRivals: () => dispatch.rivals.loadOrFetchRivals()
});

const mapStateToProps = ({rivals}) => ({rivals: rivals.items});

export default connect(mapStateToProps, mapDispatchToProps)(RivalsFilter);
